<template>
  <div class="sidebar-config__summary is-cookies">
    <div class="cookies-bar">
      <div class="cookies-bar__content">
        <h6 class="heading">{{ $t('cookiesHeading') }}</h6>
        <p v-html="$t('cookiesNotice')"></p>
        <v-button
          color="grey"
          :content="$t('iAgree')"
          @click="onAccept"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SidebarCookies',
    props: {
      onAccept: {
        type: Function,
        required: true,
      },
    },
  };
</script>
